/* eslint-disable react/display-name */

import React from 'react';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import { TYPES } from '../constants';

export const nameBuilderMapper = {
    [TYPES.CATEGORY]: (id) => <I18n k={`categories.category_${id}.name`}/>,
    [TYPES.SUB_CATEGORY]: (id) => <I18n k={`sub_categories.sub_category_${id}.name`}/>,
    [TYPES.FILTERED_PAGE]: (id) => <I18n k={`sub_categories.sub_category_${id}.name`}/>,
    [TYPES.NESTED_SUB_CATEGORY]: (id, subCategoryId) => <I18n k={`sub_categories.sub_category_${subCategoryId}.nested_sub_cat_${id}.name`}/>
};